export default __webpack_public_path__ + "static/media/INSTAGRAM.e6cd0266.svg";